<template>
<!-- 资讯预览页 -->
  <div class="previewInformation">
    <p v-show="state" class="invalid">该页面为预览效果，短期内将会失效</p>
    <div v-if="state" class="content">
      <div class="left">
        <p>
          <img src="@/assets/img/details/2.png" alt="">
          <span>收藏</span>
        </p>
        <p>
          <img src="@/assets/img/details/share.png" alt="">
          <span>分享</span>
        </p>
      </div>
      <div>
        <div v-if="previewList" class="centre">
          <p class="h" v-html="previewList.title">{{previewList.title}}</p>
          <p class="source">
            <span v-if="previewList.originalPublishTime" style="margin-right:20px;">{{previewList.originalPublishTime.slice(0,10)}}</span>
            <span v-if="previewList.createTime && !previewList.originalPublishTime">{{previewList.createTime.slice(0,10)}}</span>
            <span style="marginLeft:20px;">
              <span v-if="previewList.source">来源：{{previewList.source}}</span>
              <span v-else>来源：科技创新导报</span>
            </span>
            <span style="marginLeft:20px;" v-if="previewList.author">作者：{{previewList.author}}</span>
          </p>
          <div class="details">
            <p style="font-size: 18px;line-height: 2;" v-html="previewList.content"></p>
          </div>
        </div>
        <div class="centre">
          <div class="title">
            <div class="left"></div>
            <div class="content">最新资讯</div>
            <div class="rights"></div>
          </div>
          <div class="list">
            <ul>
              <li v-for="item in wenxian" :key="item.id">
              <span v-html="item.title">{{item.title}}</span>  
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right">
        <p class="right-1">发布者</p>
        <p class="right-2">
          <!-- <img :src="previewList.cover" alt=""> -->
          <img v-lazy="`${$global.imgUrl}${user.headImg}`" alt="">
          <span>{{user.name}}</span>
        </p>
        <div class="right-3">
          <span class="wx">
            <span style="fontSize:18px;color:#ff7d14">0</span>
            <span>文献数</span>
          </span>
          <span class="zx">
            <span style="fontSize:18px;color:#ff7d14">0</span>
            <span>资讯数</span>
          </span>
        </div>
      </div>
    </div>
    <div v-else class="images">
      <img src="@/assets/img/details/urlDisabled.png" alt="">
      <div>临时链接已失效</div>
    </div>
  </div>
</template>

<script>
export default {
  name:'previewInformation',
  components: {
    
  },
  data() {
    return {
      previewList:{},
      user:{},
      wenxian:{},
      state:true
    };
  },
  created() {
    this.setPreview()
  },
  methods:{
    // 获取详情内容
    async setPreview(){
      const resp = await this.$apis.userServe.articlePreview({
       articleId: this.$route.query.articleId
      });
      if(resp.resultCode == 200 ) {
        this.previewList = resp.data.data
        this.getAuthor()
        this.getwenxian()
      }else{
        this.state = false
      }      
    },
    // 获取发布者信息
    async getAuthor(){
      const resp = await this.$apis.recomendServe.getAuthor({
        userId:this.previewList.createUser,
        type:this.previewList.userType
      })
      if(resp.resultCode == 200){
        this.user = resp.content
      }
    },
    // 获取最新资讯
    async getwenxian(){
      let obj = {};
      this.previewList.userType === 0
        ? (obj["createUser"] = this.previewList.createUser)
        : (obj["companyId"] = this.previewList.companyId);
      let obj1 = {
        pageNo: 1,
        pageSize: 5,
      };
      obj = { ...obj, ...obj1 };
      const { data } = await this.$apis.recomendServe.getwenxian(obj)
        this.wenxian = data.list
        console.log(this.wenxian)
    }
  }
};
</script>

<style lang="scss" scoped>
.previewInformation{
  .invalid{
    margin: 0 auto 50px;
    text-align: center;
    width: 396px;
    height: 45px;
    line-height: 45px;
    background: #f9f9f9;
    border-radius: 4px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #333333;
  }
  .images{
    text-align: center;
    position: relative;
    top: 50px;
    margin-top: 50px;
    & img{
      margin-bottom: 50px;
    }
  }
  .content{
    display: flex;
    justify-content: center;
    .left{
      margin-right: 40px;
      p{
        margin-bottom:44px;
      }
      p img{
        display: block;
        width: 28px;
        height: 28px;
      }
    }
    .centre{
      width: 905px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      padding: 43px 25px;
      margin-bottom: 10px;
      .h{
        font-size: 30px;
        font-weight: bold;
        line-height: 48px;
        color: #263d78;
      }
      .source{
        margin: 15px 0;
      }
      .title{
        width: 854px;
        height: 40px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        .left{
          width: 145px;
          height: 1px;
          background: #666;
          opacity: 0.34;
        }
        .content{
          margin: 0 10px;
        }
        .rights{
         width: 145px;
          height: 1px;
          background: #666;
          opacity: 0.34;
          margin-left: 45px;
        }
      }
      .list {
        width: 794px;
        margin-left: 40px;
        li {
          list-style: outside;
          margin-bottom: 20px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          height: 24px;
          line-height: 24px;
          // cursor: pointer;
        }
      }
    }
    .right{
      width: 270px;
      height: 250px;
      border: 1px solid #A3CBE7;
      border-radius: 10px;
      margin-left: 10px;
      .right-1{
        margin: 25px 0 0 20px;
      }
      .right-2{
        text-align: center;
        img{
          width: 84px;
          height: 84px;
          border-radius: 50px;
        }
        span{
          display: block;
          color: #333333;
          font-weight: bold;
          font-size: 18px;
          margin-top: 15px;
        }
      }
      .right-3{
        margin-top: 15px;
        display: flex;
        justify-content: space-around;
        font-size: 12px;
        .wx{
          text-align: center;
          display: flex;
          flex-direction:column;
        }
        .zx{
          text-align: center;
          display: flex;
          flex-direction:column;
        }
      }
    }
  }
}
</style>
